// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentOperationInfo_wrapper__9C6Wp","text":"W_PaymentOperationInfo_text__Gc9hV"};